module.exports = __webpack_public_path__ + "img/suscribete.79c6bb4b.png";